export type ILanguageType = "en" | "zh";

// 通用列表分页请求参数
export interface IListPaginationParams {
  // 下一页 token
  nextToken?: null | string;
  // 每页大小
  limit?: number;
}

export interface IGenerateDataCacheKey {
  params: string;
  api: string;
  language?: ILanguageType;
  customerId?: string;
}

export type IListCacheOriginal = {
  [key: string]: string | undefined;
};

/**
 * Edgen AI 集成所需的认证信息
 * 用于登录Edgen平台
 * 传入 iframe 的 URL 中使用
 */
export interface IEdgenAuthToken {
  /**
   * Edgen的访问令牌
   * 用于验证用户访问权限
   * @type {string} JWT 格式的令牌字符串
   */
  accessToken: string;

  /**
   * AI 对话的唯一标识符
   * 用于关联和追踪一次完整的对话会话
   * @type {string} 对话 ID 字符串
   */
  chatId: string;
}
/**
 * KYC步骤枚举
 * 个人:0-选择国家和填写问卷，1-onfido认证，2-上传文件
 * 机构:0-填写问卷，1-填写基本信息，2-上传文件
 */
export enum EKycStep {
  QUESTIONNAIRE = 0, // 问卷阶段
  VERIFICATION = 1, // 个人是onfido认证，机构是基本信息
  UPLOAD = 2, // 上传文件阶段
}
